export default __webpack_public_path__ + "static/platform1-3f8de19ab946f2138825c31988c9b75d.svg";